/* ============================================================
   KIRSCH COFFEE — Shopify Theme JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ── Sticky Header ──────────────────────────────────── */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile Menu ────────────────────────────────────── */
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const menuOpen  = document.querySelector('.icon-menu-open');
  const menuClose = document.querySelector('.icon-menu-close');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileMenu.classList.toggle('open');
      if (menuOpen)  menuOpen.style.display  = isOpen ? 'none'  : 'block';
      if (menuClose) menuClose.style.display = isOpen ? 'block' : 'none';
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    // Close on nav link click
    mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        mobileMenu.classList.remove('open');
        if (menuOpen)  menuOpen.style.display  = 'block';
        if (menuClose) menuClose.style.display = 'none';
        document.body.style.overflow = '';
      });
    });
  }

  /* ── Desktop "Shop Coffee" category dropdown ────────── */
  const navDropdown = document.querySelector('[data-nav-dropdown]');
  if (navDropdown) {
    const navToggle = navDropdown.querySelector('[data-nav-dropdown-toggle]');
    const closeNav = () => {
      navDropdown.classList.remove('open');
      if (navToggle) navToggle.setAttribute('aria-expanded', 'false');
    };
    if (navToggle) {
      navToggle.addEventListener('click', e => {
        e.stopPropagation();
        const isOpen = navDropdown.classList.toggle('open');
        navToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }
    document.addEventListener('click', e => {
      if (!navDropdown.contains(e.target)) closeNav();
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') closeNav();
    });
  }

  /* ── Mobile "Shop Coffee" category sub-menu ─────────── */
  const mobileShop = document.querySelector('[data-mobile-shop]');
  const mobileShopToggle = document.querySelector('[data-mobile-shop-toggle]');
  if (mobileShop && mobileShopToggle) {
    mobileShopToggle.addEventListener('click', () => {
      const isOpen = mobileShop.classList.toggle('open');
      mobileShopToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /* ── Toast Notification ─────────────────────────────── */
  function showToast(message, duration = 3000) {
    let container = document.querySelector('.toast-container');
    if (!container) {
      container = document.createElement('div');
      container.className = 'toast-container';
      document.body.appendChild(container);
    }
    const toast = document.createElement('div');
    toast.className = 'toast';
    toast.textContent = message;
    container.appendChild(toast);
    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transition = 'opacity 0.3s ease';
      setTimeout(() => toast.remove(), 350);
    }, duration);
  }

  /* ── Cart Count Update ──────────────────────────────── */
  function updateCartCount(count) {
    document.querySelectorAll('.cart-count, [data-cart-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
    // Keep the screen-reader label on the cart link in sync with AJAX updates,
    // otherwise assistive tech announces a stale count until the next reload.
    document.querySelectorAll('.cart-icon-btn').forEach(el => {
      el.setAttribute('aria-label', 'Cart (' + count + (count === 1 ? ' item)' : ' items)'));
    });
  }

  /* ── Site-wide "what's chosen" sync ─────────────────── */
  /* The Shopify cart is the single source of truth. Any product card that
     carries a [data-variant-id] gets an "In cart" state reflecting the live
     cart, and a `kirsch:cart` event is broadcast so sections (bundle picker,
     free-shipping bar) can re-render themselves. Anything that mutates the
     cart should call window.KirschCart.refresh() afterwards. */
  function applyCartToProductCards(cart) {
    const qtyByVariant = {};
    (cart && cart.items ? cart.items : []).forEach(it => {
      qtyByVariant[it.variant_id] = (qtyByVariant[it.variant_id] || 0) + it.quantity;
    });
    document.querySelectorAll('.product-card [data-incart]').forEach(badge => {
      const card = badge.closest('.product-card');
      if (!card) return;
      // Sum across every variant id on the card so the badge reflects the
      // product no matter which variant the shopper added.
      const ids = (badge.dataset.variantIds || '').split(',');
      let qty = 0;
      ids.forEach(id => {
        const n = parseInt(id, 10);
        if (n) qty += qtyByVariant[n] || 0;
      });
      card.classList.toggle('is-in-cart', qty > 0);
      badge.hidden = qty === 0;
      badge.textContent = qty > 1 ? ('In cart · ' + qty) : 'In cart';
    });
  }

  function hydrateCart(cart) {
    if (!cart) return;
    if (cart.item_count !== undefined) updateCartCount(cart.item_count);
    applyCartToProductCards(cart);
    document.dispatchEvent(new CustomEvent('kirsch:cart', { detail: cart }));
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(cart => { hydrateCart(cart); return cart; })
      .catch(() => {});
  }

  window.KirschCart = { refresh: refreshCart, hydrate: hydrateCart };

  /* ── Add to Cart (AJAX) ─────────────────────────────── */
  function addToCart(variantId, quantity, button) {
    if (!variantId) return;

    const originalText = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Adding...'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 }),
    })
      .then(res => res.json())
      .then(item => {
        if (item.status) {
          showToast(item.description || 'Could not add item to cart.');
          return;
        }
        // Refresh cart count + every "chosen" indicator across the page.
        return fetch('/cart.js').then(r => r.json());
      })
      .then(cart => {
        if (cart && cart.item_count !== undefined) {
          hydrateCart(cart);
          showToast('Added to cart ✓');
        }
      })
      .catch(() => showToast('Error adding to cart.'))
      .finally(() => {
        if (button) { button.disabled = false; button.textContent = originalText; }
      });
  }

  /* ── Quick Add Buttons (Shop Grid) ──────────────────── */
  document.querySelectorAll('[data-quick-add]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      const variantId = btn.dataset.variantId;
      addToCart(variantId, 1, btn);
    });
  });

  /* ── Product Detail Page ────────────────────────────── */
  const productForm = document.getElementById('product-form');
  if (productForm) {
    // Variant selection
    const variantBtns = productForm.querySelectorAll('.variant-btn');
    const priceEl = document.querySelector('.product-detail__price-current');
    const comparePriceEl = document.querySelector('.product-detail__price-compare');
    const addBtn = productForm.querySelector('.btn-add-to-cart');
    const variantIdInput = productForm.querySelector('[name="id"]');
    const mainImage = document.querySelector('.product-detail__main-img');

    variantBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        variantBtns.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');

        const price = btn.dataset.price;
        const comparePrice = btn.dataset.comparePrice;
        const available = btn.dataset.available === 'true';
        const variantId = btn.dataset.variantId;
        const image = btn.dataset.image;

        if (variantIdInput) variantIdInput.value = variantId;
        if (priceEl && price) priceEl.textContent = price;
        if (comparePriceEl) {
          if (comparePrice && comparePrice !== price) {
            comparePriceEl.textContent = comparePrice;
            comparePriceEl.style.display = 'inline';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }
        if (addBtn) {
          addBtn.disabled = !available;
          addBtn.textContent = available ? 'Add to Cart' : 'Out of Stock';
        }
        if (mainImage && image) {
          mainImage.src = image;
        }
      });
    });

    // Quantity
    const qtyInput = productForm.querySelector('.quantity-input');
    const qtyMinus = productForm.querySelector('[data-qty-minus]');
    const qtyPlus  = productForm.querySelector('[data-qty-plus]');

    if (qtyInput) {
      if (qtyMinus) qtyMinus.addEventListener('click', () => {
        const val = parseInt(qtyInput.value) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
      if (qtyPlus) qtyPlus.addEventListener('click', () => {
        qtyInput.value = (parseInt(qtyInput.value) || 1) + 1;
      });
    }

    // Add to cart submit
    if (addBtn) {
      addBtn.addEventListener('click', e => {
        e.preventDefault();
        const variantId = variantIdInput ? variantIdInput.value : null;
        const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
        addToCart(variantId, qty, addBtn);
      });
    }

    // Thumbnail gallery
    const thumbs = document.querySelectorAll('.product-detail__thumb');
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        if (mainImage && thumb.dataset.src) {
          mainImage.src = thumb.dataset.src;
        }
      });
    });
  }

  /* ── Cart Page ──────────────────────────────────────── */
  function initCartPage() {
    // Remove item
    document.querySelectorAll('[data-cart-remove]').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.cartRemove;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 }),
        })
          .then(() => window.location.reload())
          .catch(() => showToast('Error removing item.'));
      });
    });

    // Quantity change
    document.querySelectorAll('[data-cart-qty]').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const currentQty = parseInt(btn.closest('.cart-item').querySelector('[data-qty-display]').textContent);
        const delta = btn.dataset.cartQty === 'plus' ? 1 : -1;
        const newQty = Math.max(0, currentQty + delta);

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty }),
        })
          .then(() => window.location.reload())
          .catch(() => showToast('Error updating cart.'));
      });
    });
  }

  if (document.querySelector('.cart-page')) {
    initCartPage();
  }

  /* Hero mute control is handled by the inline <script> at the bottom of
     sections/hero-banner.liquid. The previous fallback handler here was
     binding to the same #hero-mute-btn and double-flipping video.muted
     on every click (net effect: still muted) — root cause of the bug
     where the unmute button appeared to do nothing. Do NOT re-introduce
     a second click handler for #hero-mute-btn. */

  /* ── Collection Filter Links ────────────────────────── */
  // Active filter state is set server-side via Liquid; this handles any JS needs
  document.querySelectorAll('.filter-btn').forEach(btn => {
    if (btn.href && window.location.href.includes(btn.href.split('?')[1] || '____')) {
      btn.classList.add('active');
    }
  });

  /* ── Initial cart hydrate ───────────────────────────── */
  // Pull the live cart once on load so every "In cart" badge, the cart count
  // and any cart-driven section (bundle picker, free-shipping bar) reflect what
  // the customer has already chosen. The fetch resolves asynchronously, after
  // all section scripts have registered their `kirsch:cart` listeners.
  refreshCart();

})();
